import { render, staticRenderFns } from "./ContentSpinner.vue?vue&type=template&id=36de4b30&scoped=true"
import script from "./ContentSpinner.vue?vue&type=script&lang=js"
export * from "./ContentSpinner.vue?vue&type=script&lang=js"
import style0 from "./ContentSpinner.vue?vue&type=style&index=0&id=36de4b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de4b30",
  null
  
)

export default component.exports